
	import { Component, Watch, Vue } from 'vue-property-decorator';
	import alertServiceModule, { AlertServiceModule } from '@/HostApp/services/AlertService/AlertServiceModule';
	import ViewportWrapper from '@/HostApp/ui/system/ViewportWrapper.vue';
	import appModule from '@/HostApp/store/ApsModules/AppModule';
	import { IAlertMessage } from 'types';
	import { getT } from '@/Framework/app/translate';

	const $t = getT();

	@Component({
		components: { ViewportWrapper }
	})
	export default class AlertNode extends Vue {
		protected get alertService(): AlertServiceModule {
			return alertServiceModule;
		}

		protected get alerts(): Array<APS.IAlertMessage> {
			return alertServiceModule.currentApplicationMessages;
		}

		protected get viewId(): string {
			return appModule.currentView.id;
		}

		@Watch('viewId')
		protected viewIdChanged(newVal: string, oldVal: string): void {
			if (newVal !== oldVal) {
				alertServiceModule.removeAppMessages(oldVal);
			}
		}

		protected handleRemoveAlert(idx: number): void {
			alertServiceModule.removeMessage(idx);
		}

		protected computeMessageDescription(alert: IAlertMessage) {
			if (alert.type === 'error') {
				const regex = /(Something went wrong|Failed to fetch|Cannot post:|Status code:)/;
				const defaultMessage = $t('Something went wrong. Please retry or contact support.');
				return regex.test(alert.details) ? defaultMessage : this.removeIMAndBackendMessages(alert.details);
			} else {
				return alert.details;
			}
		}
		protected computeMessageSessionDetails(alert: IAlertMessage) {
			const id = alert.correlationId || '';
			const currentTime = new Date().toISOString();
			return this.prepareSessionDetailsMessage(id, currentTime);
		}
		protected prepareSessionDetailsMessage(...args: string[]): string {
			const filteredArgs = args.filter((arg) => !!arg);
			return filteredArgs.length > 0 ? `Session Details: ${filteredArgs.join(' · ')}` : '';
		}

		protected removeIMAndBackendMessages(message: string) {
			return message
				.replace(/((?:\w+\.)+\w+:)|(ingram\s*micro)/gi, '')
				.replace(/\s+/g, ' ')
				.trim();
		}
	}
